import {Component, NgZone, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Params, Router} from '@angular/router';

import {SitesService} from '../../shared/services/sites.service';
import {AuthService} from '../../shared/services/auth.service';

import {SiteModel} from '../../shared/models/site.model';
import {MessageModel} from '../../shared/models/message.model';

@Component({
  selector: 'lba-login',
  templateUrl: './login.component.html',
})
export class LoginComponent implements OnInit {

  form: FormGroup;
  message: MessageModel;

  constructor(
    private authService: AuthService,
    private siteService: SitesService,
    private router: Router,
    private route: ActivatedRoute,
    private _ngZone: NgZone,
  ) {

  }

  ngOnInit() {
    this.message = new MessageModel('danger', '');
    this.form = new FormGroup({
      'username': new FormControl(null, [Validators.required, Validators.minLength(3)]),
      'password': new FormControl(null, [Validators.required, Validators.minLength(3)]),
    });
    this.route.queryParams.subscribe((params: Params) => {
      if (params['accessDenied']) {
        this.showMessage('Please login to the System', 'Bad Request')
      }
    })
  }

  private showMessage(text: string, type: string = 'danger') {
    this.message = new MessageModel(type, text);
    window.setTimeout(() => {
      this.message.message = '';
      this.message.status = '';
    }, 5000);
  }

  login() {
    const formData = this.form.value;

    this.siteService.getAvailableSites(formData.username, formData.password)
      .subscribe(
        (sites: SiteModel[]) => {
          // console.log(sites);
          this.showMessage('Ok', 'success');
          if (sites.length > 0) {
            this.authService.login(formData.username, formData.password);
            if (this.authService.isLoggedIn()) {
              this._ngZone.run(() => {
                this.router.navigate(['/pages', 'sites']);
              });
            } else {
              // console.log('is not logged in');
              this.showMessage('Please try to login again', 'Bad Request')
            }
          } else {
            this.showMessage('You do not have access to edit sites', 'Bad Request')
          }
        },
        error => {
          console.log(error);
          this.showMessage(error.message, error.status);
        });
  }

}
